export enum StructureStatusEnum {
  Normal = 'normal',
  Archived = 'archived',
}
